<template>
  <div class="lb">
    <div
      ref="barMian"
      class="barMian"
      @mouseover="autoTimePaused = true"
      @mouseout="autoTimePaused = false"
    ></div>
  </div>
</template>


<script>
import * as methods from './method.js'
export default {
  name: 'template.scope46',
  props: {
    vdata: {
      type: [Array, String],
      default: () => []
    },
    jsondata: {
      type: [Array, String],
      default: () => []
    },
    scopedata: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      title: '斑马纹理柱状图-带背景-scope46',
      timer: null,
      defaultdata: [
        { value1: "1月", value2: "80", value3: "系列一", value4: '元' },
        { value1: "2月", value2: "40" },
        { value1: "3月", value2: "62" },
        { value1: "4月", value2: "90" },
        { value1: "5月", value2: "62" },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "数值", key: "value2" },
        { name: "图例", key: "value3" },
        { name: "单位", key: "value4" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    }
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
      }
    },
    jsondata(n) {
      this.exceldata = n
    },
    defaultdata(n) {
      this.DrawEcharts()
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let unit = this.defaultdata[0].value4 || ''
      let mydata = this.defaultdata.map((item) => {
        return {
          name: item.value1,
          value: item.value2,
        };
      });
      const xAxis = this.defaultdata.map((item) => {
        return item.value1;
      });
      const percent = (7 / xAxis.length) * 100;
      let zoom = [
        {
          id: "scope46", // 唯一的id
          type: 'slider',
					moveHandleSize: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
          backgroundColor: "transparent",
          fillerColor:"rgba(0,0,0,.2)",
          borderColor:"transparent",
          start: 0,
          brushSelect: false,
          end: percent,
          zlevel: 3, //重点，层级必须设置大于柱状图
        },
      ];
      var Toption = {
        title: [
          {
            text: unit,
            top: "0",
            left: "0",
            textStyle: {
              color: "#979AA0",
              fontSize: 12,
              width: 80,
              overflow: 'truncate'
            },
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: [
          {
            top: "2%",
            right: "40%",
            itemHeight: 12, //图例的高度  文字左边那个
            itemWidth: 10,
            icon: "rect",
            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },

            data: [this.defaultdata[0].value3 || ""],
          },
        ],
        grid: {
          left: "5px",
          right: "10px",
          bottom: "0px",
          top: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: mydata.map((item) => item.name),
          axisLabel: {
            interval: 0,
            width: 50,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
            formatter: function (value) {
              return value
            },
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          splitNumber: 4,
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              color: "#151d31",
            },
            tooltip: {
              show: false,
            },

            showBackground: true, //控制是否显示背景色
            backgroundStyle: {
              // color: 'rgba(180, 180, 180, 0.4)' //背景色的颜色
              color: "#141412",
            },
            barWidth: 20,
            // barWidth: 15,
            barGap: "40%",
            data: mydata,
          },
          {
            data: mydata,
            name: this.defaultdata[0].value3 || "",
            type: "bar",
            z: 1,
            zlevel: 2, //重点，层级必须设置大于柱状图
            barGap: "80%",
            type: "pictorialBar",
            symbol: "rect",
            symbolMargin: 2,
            symbolRepeat: true,
            symbolSize: ["50%", 3],
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0182fc", // 0% 处的颜色
                    },
                    {
                      offset: 0.8,
                      color: "#0182fc", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#032042", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
        ],
        dataZoom: xAxis.length > 7 ? zoom : [],
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {

  },
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata
    }
    this.setData()
    this.DrawEcharts(); //需要刷新的数据
  },
}
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
